import React from 'react'
import img1 from './assets/img1.png';
import img2 from './assets/img2.png';
import img3 from  './assets/img3.png';
import img4 from  './assets/img4.png';

import img5 from './assets/bookStore_img.png'

import img6 from './assets/assesment_img1.png'
import img7 from './assets/assesment_img2.png'

import img8 from './assets/devDetactive_img1.png'
import img9 from './assets/devDetactive_img2.png'

import img10 from './assets/space_img_1.png'
import img11 from './assets/space_img_2.png'
import img12 from './assets/space_img_3.png'
import img13 from './assets/space_img_4.png'

import img14 from './assets/razorpay_img.png'

import img15 from './assets/college management.png'

import img16 from './assets/time_management.png'

export const Images = () => {
  return (
    <div className='flex flex-wrap gap-3'>
        <img src={img1} alt=""  className='w-[180px] h-[180px]'/>
        <img src={img2} alt=""  className='w-[180px] h-[180px]'/>
        <img src={img3} alt="" className='w-[180px] h-[180px]' />
        <img src={img4} alt="" className='w-[180px] h-[180px]' />

        <img src={img5} alt="" className='w-[180px] h-[180px]' />

        <img src={img6} alt="" className='w-[180px] h-[180px]' />
        <img src={img7} alt="" className='w-[180px] h-[180px]' />

        <img src={img8} alt="" className='w-[180px] h-[180px]' />
        <img src={img9} alt="" className='w-[180px] h-[180px]' />

        <img src={img10} alt="" className='w-[180px] h-[180px]' />
        <img src={img11} alt="" className='w-[180px] h-[180px]' />
        <img src={img12} alt="" className='w-[180px] h-[180px]' />
        <img src={img13} alt="" className='w-[180px] h-[180px]' />

        <img src={img14} alt="" className='w-[180px] h-[180px]' />

        <img src={img15} alt="" className='w-[180px] h-[180px]' />

        <img src={img16} alt="" className='w-[180px] h-[180px]' />
    </div>
  )
}
